import { render, staticRenderFns } from "./ComplexWriteBody.vue?vue&type=template&id=c03b4238&scoped=true"
import script from "./ComplexWriteBody.vue?vue&type=script&lang=js"
export * from "./ComplexWriteBody.vue?vue&type=script&lang=js"
import style0 from "./ComplexWriteBody.vue?vue&type=style&index=0&id=c03b4238&prod&scoped=true&lang=scss"
import style1 from "./ComplexWriteBody.vue?vue&type=style&index=1&id=c03b4238&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03b4238",
  null
  
)

export default component.exports